export interface HubSpotLinkedFilterType {
  linked: server.dto.LinkedFilterSettings
}

export const initialHubSpotLinkedFilter: HubSpotLinkedFilterType = {
  linked: "noFilter"
};